import { render } from "./MiruWonderland.vue?vue&type=template&id=1254eb57"
import script from "./MiruWonderland.vue?vue&type=script&lang=js"
export * from "./MiruWonderland.vue?vue&type=script&lang=js"

import "./MiruWonderland.vue?vue&type=style&index=0&id=1254eb57&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__